import React, { createContext, useContext, useState, ReactNode } from 'react';

interface CartAnimationContextType {
  isAnimating: boolean;
  triggerAnimation: () => void;
}

const CartAnimationContext = createContext<CartAnimationContextType | undefined>(undefined);

export const useCartAnimation = () => {
  const context = useContext(CartAnimationContext);
  if (context === undefined) {
    throw new Error('useCartAnimation must be used within a CartAnimationProvider');
  }
  return context;
};

interface CartAnimationProviderProps {
  children: ReactNode;
}

export const CartAnimationProvider: React.FC<CartAnimationProviderProps> = ({ children }) => {
  const [isAnimating, setIsAnimating] = useState(false);

  const triggerAnimation = () => {
    setIsAnimating(true);
    setTimeout(() => setIsAnimating(false), 1000);
  };

  return (
    <CartAnimationContext.Provider value={{ isAnimating, triggerAnimation }}>
      {children}
    </CartAnimationContext.Provider>
  );
};
